import {
  Box,
  Flex,
  HStack,
  Select,
  SimpleGrid,
  Skeleton,
  Stat,
  StatLabel,
  StatNumber,
  Text,
  Tooltip,
  useColorModeValue,
  VStack,
} from '@chakra-ui/react';
import IconBox from '../../../components/Icons/IconBox';
import React from 'react';
import Card from '../../../components/Card/Card';
import CardBody from '../../../components/Card/CardBody';
import CardHeader from '../../../components/Card/CardHeader';
import { DashboardViewProps } from './interfaces';
import { useDashboardViewController } from './dasboard.controller';
import ReactApexChart from 'react-apexcharts';
import { TagsIcon } from '../../../icons/TagsIcon';
import { PeopleIcon } from '../../../icons/PeopleIcon';
import { SingleTagIcon } from '../../../icons/SingleTagIcon';
import { GridIcon } from '../../../icons/GridIcon';
import { HeartIcon } from '../../../icons/HeartIcon';

const Dashboard: React.FC<DashboardViewProps> = ({
  useController = useDashboardViewController,
}) => {
  const controller = useController();
  const textColor = useColorModeValue('gray.700', 'white');

  const period = [
    {
      label: 'Últimos 7 días',
      value: '7daysAgo',
    },
    {
      label: 'Últimos 30 días',
      value: '30daysAgo',
    },
    {
      label: 'Últimos 60 días',
      value: '60daysAgo',
    },
    {
      label: 'Últimos 90 días',
      value: '90daysAgo',
    },
  ];

  return (
    <Flex flexDirection="column" mt={0}>
      <HStack justifyContent="space-between" mb="28px">
        <VStack alignItems="flex-start">
      <Text color={textColor} fontSize="20px" fontWeight="500" lineHeight="28px" mb="4px">
      Dashboard
      </Text>
      <Text color={textColor} fontSize="16px" fontWeight="400" lineHeight="24px" mb="24px">
      Mira cómo Bikleta impacta en tu negocio
      </Text>
      </VStack>
      <Select
        placeholder="Selecciona un Periodo"
        w="250px"
        value={controller.selectedPeriod}
        onChange={(e) => controller.setSelectedPeriod(e.target.value)}
        defaultValue={controller.selectedPeriod}
      >
        {period.map((period) => (
          <option key={period.value} value={period.value}>
            {period.label}
          </option>
        ))}
      </Select>

      </HStack>

      <SimpleGrid columns={{ sm: 1, md: 4 }} spacing="24px">
        <Card
          minH="40px"
          w="100%"
          bgColor={'backgroundColor.100'}
          variant={'panel'}>
          <CardBody>
            <Flex flexDirection="row" align="center" justify="center" w="100%">
              <Stat me="auto">
                <StatLabel
                  fontSize="16px"
                  color="white"
                  fontWeight="500"
                  lineHeight="24px"
                  mb="6px"
                  >
                  Impresión
                </StatLabel>
                <Flex>
                  <Skeleton
                    minW={'60%'}
                    isLoaded={
                      !controller.loadingAnalytics && !controller.isRefreshing
                    }>
                    <HStack gap={2}>
                      <PeopleIcon boxSize="1.7rem" />
                      <StatNumber fontSize="28px" fontWeight="500" lineHeight="32px" color={textColor}>
                        {controller.analyticsData?.benefit_viewed}
                      </StatNumber>
                    </HStack>
                  </Skeleton>
                </Flex>
              </Stat>
              <Tooltip
                hasArrow
                placement="top"
                color={'white'}
                bgColor={'#201F1E'}
                label={
                  <Box textAlign="center">
                    Personas que ingresaron a tu <br /> sección de beneficios
                  </Box>
                }>
                <span>
                  <IconBox boxSize="4rem" bg={'#FFC700'}>
                    <TagsIcon boxSize="32px" />
                  </IconBox>
                </span>
              </Tooltip>
            </Flex>
          </CardBody>
        </Card>

        <Card minH="83px" bgColor={'backgroundColor.100'}>
          <CardBody>
            <Flex flexDirection="row" align="center" justify="center" w="100%">
              <Stat me="auto">
                <StatLabel
                  fontSize="16px"
                  color="white"
                  fontWeight="500"
                  lineHeight="24px"
                  mb="6px"
                  >
                  Alcance
                </StatLabel>
                <Flex>
                  <Skeleton
                    minW={'60%'}
                    isLoaded={
                      !controller.loadingAnalytics && !controller.isRefreshing
                    }>
                      <HStack gap={2}>
                      <PeopleIcon boxSize="1.7rem" />
                      <StatNumber fontSize="28px" fontWeight="500" lineHeight="32px" color={textColor}>
                      {controller.analyticsData?.benefit_detail_opened}
                      </StatNumber>
                    </HStack>
                  </Skeleton>
                </Flex>
              </Stat>
              <Tooltip
                hasArrow
                placement="top"
                color={'white'}
                bgColor={'#201F1E'}
                label={
                  <Box textAlign="center">Personas a las que les interesó <br/> alguno de tus beneficios</Box>
                }
                >
                <span>
                  <IconBox boxSize="4rem" bg={'#6FA7E1'}>
                    <SingleTagIcon boxSize="1.7rem" />
                  </IconBox>
                </span>
              </Tooltip>
            </Flex>
          </CardBody>
        </Card>

        <Card minH="83px" bgColor="backgroundColor.100">
          <CardBody>
            <Flex flexDirection="row" align="center" justify="center" w="100%">
              <Stat me="auto">
                <StatLabel
                  fontSize="16px"
                  color="white"
                  fontWeight="500"
                  lineHeight="24px"
                  mb="6px"
                  >
                  Canje
                </StatLabel>
                <Flex>
                  <Skeleton
                    minW={'60%'}
                    isLoaded={
                      !controller.loadingAnalytics && !controller.isRefreshing
                    }>
                    <HStack gap={2}>
                      <PeopleIcon boxSize="1.7rem" />
                      <StatNumber fontSize="28px" fontWeight="500" lineHeight="32px" color={textColor}>
                      {controller.analyticsData?.benefit_qr_generated}
                      </StatNumber>
                    </HStack>
                  </Skeleton>
                </Flex>
              </Stat>
              <Tooltip
                hasArrow
                placement="top"
                color={'white'}
                bgColor={'#201F1E'}
                label = {
                  <Box textAlign="center">Personas que ingresaron al QR <br/> de uno de tus beneficios</Box>
                }
                >
                <span>
                  <IconBox boxSize="4rem" bg={'#C46AE7'}>
                    <GridIcon boxSize="1.7rem" />
                  </IconBox>
                </span>
              </Tooltip>
            </Flex>
          </CardBody>
        </Card>

        <Card minH="83px" bgColor="backgroundColor.100">
          <CardBody>
            <Flex flexDirection="row" align="center" justify="center" w="100%">
              <Stat me="auto">
                <StatLabel
                   fontSize="16px"
                   color="white"
                   fontWeight="500"
                   lineHeight="24px"
                   mb="6px"
                   >
                  Compra
                </StatLabel>
                <Flex>
                  <Skeleton
                    minW={'60%'}
                    isLoaded={
                      !controller.loadingAnalytics && !controller.isRefreshing
                    }>
                    <HStack gap={2}>
                      <PeopleIcon boxSize="1.7rem" />
                      <StatNumber fontSize="28px" fontWeight="500" lineHeight="32px" color={textColor}>
                      {controller.analyticsData?.coupons_redeemed}
                      </StatNumber>
                    </HStack>
                  </Skeleton>
                </Flex>
              </Stat>
              <Tooltip
                hasArrow
                placement="top-start"
                color={'white'}
                bgColor={'#201F1E'}
                label = {
                  <Box textAlign="center">Personas que usaron alguno <br/> de tus beneficios</Box>
                }
                >
                <span>
                  <IconBox boxSize="4rem" bg={'#33C357'}>
                    <HeartIcon boxSize="2.5rem" />
                  </IconBox>
                </span>
              </Tooltip>
            </Flex>
          </CardBody>
        </Card>
      </SimpleGrid>

      <Card bgColor={'backgroundColor.100'} mt={5}>
        <CardHeader>
          <Flex
            direction="row"
            w={'100%'}
            alignSelf="flex-start"
            justifyContent={'space-between'}>
            <Text fontSize="lg" color={textColor} fontWeight="bold" mb="6px">
              Resumen de interacciones
            </Text>
            {/* <Button
              leftIcon={<MdRefresh />}
              onClick={() => controller?.analyticsData && controller.statsRefresh()}
              isLoading={controller.isRefreshing}>
              Actualizar
            </Button> */}
          </Flex>
        </CardHeader>
        <Box w="100%" h={{ sm: '300px' }} ps="8px">
          {controller.analyticsData && (
            <ReactApexChart
              options={{
                chart: {
                  type: 'bar',
                  toolbar: {
                    show: false,
                  }
                },
                plotOptions: {
                  bar: {
                    horizontal: false,
                    columnWidth: '55%',
                    borderRadius: 5,
                    distributed: true,
                  },
                },
                colors: ['#FFC700', '#6FA7E1', '#C46AE7', '#33C357'],
                dataLabels: {
                  enabled: false,
                },
                stroke: {
                  show: true,
                  width: 2,
                  colors: ['transparent']
                },
                xaxis: {
                  categories: ['Impresión', 'Alcance', 'Canje', 'Compras'],
                  labels: {
                    style: {
                      colors: 'white',
                      fontSize: '14px',
                      fontWeight: '400',
                    },
                  },
                  
                },
                yaxis: {
                  title: {
                    text: 'Cantidad de interacciones',
                    style: {
                      color: 'white',
                      fontSize: '14px',
                      fontWeight: '400',
                    },
                  },
                },
                fill: {
                  opacity: 1
                },
                tooltip: {
                  theme: 'dark',
                  y: {
                    formatter: function (val) {
                      return val + ''
                    }
                  }
                },
                legend: {
                  show: false,
                },
              }}
              series={[{
                name: 'Interacciones',
                data: [
                  controller.analyticsData.benefit_viewed || 0,
                  controller.analyticsData.benefit_detail_opened || 0,
                  controller.analyticsData.benefit_qr_generated || 0,
                  controller.analyticsData.coupons_redeemed || 0
                ]
              }]}
              type="bar"
              width="100%"
              height="100%"
            />
          )}
        </Box>
      </Card>
    </Flex>
  );
};

export default Dashboard;
